var map = {
	"./0.1.jpg": "ed3e",
	"./0.2.jpg": "d637",
	"./0.3.jpg": "44d3",
	"./0.4.jpg": "135c",
	"./1.2.jpg": "4f39",
	"./1.3.jpg": "75da",
	"./1.4.jpg": "35d1",
	"./2.1.1.jpg": "bce8",
	"./2.1.2.jpg": "2176",
	"./2.1.3.jpg": "94cb",
	"./2.1.4.jpg": "853f",
	"./2.1.5.jpg": "60f0",
	"./2.1.6.jpg": "1c2f",
	"./2.1.7.jpg": "36b6",
	"./2.2.1A.jpg": "cc78",
	"./2.2.1B.jpg": "d29d",
	"./2.2.2.jpg": "b311",
	"./2.2.2A.jpg": "e2b0",
	"./2.2.2B.jpg": "02b3",
	"./2.2.3A.jpg": "82b8",
	"./2.2.3B.jpg": "53ba",
	"./2.2.4A.jpg": "9e90",
	"./2.3.1.jpg": "b9d4",
	"./2.3.2.jpg": "7cd8",
	"./2.3.3.jpg": "986a",
	"./2.3.4.jpg": "aa96",
	"./2.3.5.jpg": "95e2",
	"./2.3.6.jpg": "cb58",
	"./2.4.1.jpg": "5ba9",
	"./2.5.1.jpg": "1279",
	"./2.5.2.jpg": "a0c3",
	"./2.5.3.jpg": "1196",
	"./2.5.4.jpg": "53dd",
	"./Fondo.png": "5065",
	"./by-nc-nd.png": "c181",
	"./by-nc-sa.eu.png": "fe84",
	"./commision-cz.jpg": "1721",
	"./commision-en.jpg": "8fa9",
	"./commision-es.jpg": "1c69",
	"./commision-it.jpg": "74f4",
	"./commision-pt.jpg": "1504",
	"./cz.svg": "26c7",
	"./es.svg": "0815",
	"./gb.svg": "bf20",
	"./it.svg": "03e3",
	"./line.png": "aa06",
	"./logo.jpg": "b640",
	"./logo.png": "cf05",
	"./memphis-colorful.png": "c5f3",
	"./no-image.png": "bd21",
	"./pt.svg": "abd8",
	"./test.jpg": "724e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";